import { render, staticRenderFns } from "./NewsTypeList.vue?vue&type=template&id=719a0126&"
import script from "./NewsTypeList.vue?vue&type=script&lang=js&"
export * from "./NewsTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports